import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
export var resetEditorPublishResults = createAction(actionTypePrefix + "/RESET_EDITOR_PUBILSH_RESULTS", function (editorId) { return editorId; });
export var publishComment = createAction(actionTypePrefix + "/PUBLISH_COMMENT", function (publisher) { return publisher; });
export var publishCommentSuccess = createAction(actionTypePrefix + "/PUBLISH_COMMENT_SUCCESS", function (result) { return result; });
export var publishCommentFailure = createAction(actionTypePrefix + "/PUBLISH_COMMENT_FAILURE", function (result) { return result; });
export var focusEditor = createAction(actionTypePrefix + "/FOCUS_EDITOR", function (editorId) { return ({
    editorId: editorId,
}); });
export var focusEditorWithScroll = createAction(actionTypePrefix + "/FOCUS_EDITOR_WITH_SCROLL", function (editorId, smoothScroll) { return ({
    editorId: editorId,
    smoothScroll: smoothScroll,
}); });
export var focusDone = createAction(actionTypePrefix + "/FOCUS_DONE", function (editorId) { return ({
    editorId: editorId,
}); });
//# sourceMappingURL=actionCreators.js.map